<!-- this field is optional -->
<template>
  <div>
    <div class="form__group--border pt-32 pb-16">
      <fieldset>
        <legend class="form__label pb-8">{{ legend }}</legend>
        <ul>
          <li v-for="experienceType in experienceTypes" :key="experienceType.value">
            <PoppinsCheckbox
              v-model="experience"
              name="caretype-experience"
              :label-name="experienceType.optionText"
              :aria-label="generateScreenReaderLabel(experienceType.optionText)"
              :value="experienceType.value"
            />
          </li>
        </ul>
      </fieldset>
    </div>
  </div>
</template>

<script lang="ts">
import Checkbox from '@/components/checkbox/Checkbox.vue';

export default {
  name: 'ExperienceCheckbox',
  components: {
    PoppinsCheckbox: Checkbox,
  },
  props: {
    experienceTypes: {
      type: Object,
      required: true,
    },
    generateScreenReaderLabel: {
      type: Function,
      required: true,
    },
    legend: {
      type: String,
      required: true,
    },
  },
  computed: {
    experience: {
      get() {
        return this.$store.getters.getFormField('experience');
      },
      set(newValue) {
        return this.$store.dispatch('updateForm', { key: 'experience', value: newValue });
      },
    },
  },
};
</script>
